import { configureStore } from '@reduxjs/toolkit';
import searchReducer from './slices/searchSlice';
import layoutReducer from './slices/layoutSlice';
import cacheReducer from './slices/cacheSlice';

export const store = configureStore({
  reducer: {
    search: searchReducer,
    layout: layoutReducer,
    cache: cacheReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 